import React, { useState } from "react";
import { ReactComponent as DeleteEntrySvg } from "assets/images/challenges/time-left.svg";

const ChallengeProgressBar = ({ details, getTimeWidth, getGoalWidth }) => {
  return (
    <div className="challenge-progress-bar">
      {details.goal !== null && (
        <DeleteEntrySvg
          className="time-icon"
          width={28}
          height={28}
          style={{
            translate: `${getTimeWidth() * 10}%`,
            marginLeft: `${getTimeWidth() > 10 ? -10 : 0}`
          }}
        />
      )}
      <div className="bar-container">
        <div
          className="filled-bar"
          style={{
            width: `${details.goal !== null ? getGoalWidth() : getTimeWidth()}%`
          }}
        ></div>
      </div>
    </div>
  );
};

export default ChallengeProgressBar;
